// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3CoYE","topBottomGutter":"Layout_topBottomGutter__3MLnm"};